import(/* webpackMode: "eager" */ "/vercel/path0/app/ressurser/ebook/page.tsx");
